import { TableCell } from "@mui/material";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";

interface TableActionsProps {
  navigateTo?: string;
  onClick?: () => void;
}

export default function TableActions(props: TableActionsProps) {
  const cellStyle = { padding: "8px 16px", fontSize: "14px" };
  return (
    <TableCell
      sx={{
        ...cellStyle,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {props.navigateTo && <EditButton navigateTo={props.navigateTo} />}
      {props.onClick && <DeleteButton onClick={props.onClick} />}
    </TableCell>
  );
}
